<template>
  <div class="cw-accordion">
    <button class="cw-accordion--title drag-handle" type="button" @click="$emit('click')">
      <div class="cw-accordion--title-wrap">
        <emoji-or-icon class="icon-or-emoji" :icon="icon" :emoji="emoji" />
        <h5>
          {{ title }}
        </h5>
      </div>
      <div class="button-icon--wrap">
        <slot name="button" />
        <div class="chevron-icon__wrap" :class="{ 'is-open': isOpen }">
          <fluent-icon size="24" icon="chevron-down" />
        </div>
      </div>
    </button>
    <transition name="slide">
      <div v-if="isOpen" class="cw-accordion--content-wrap">
        <div
        class="cw-accordion--content"
        :class="{ compact: compact }"
        >
          <div class="cw-accordion--internal-content">
            <slot />
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import EmojiOrIcon from 'shared/components/EmojiOrIcon';

export default {
  components: {
    EmojiOrIcon,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    compact: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: '',
    },
    emoji: {
      type: String,
      default: '',
    },
    isOpen: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.cw-accordion {
  margin-top: -1px;
  font-size: var(--font-size-small);
}
.cw-accordion--title {
  align-items: center;
  background: var(--s-50);
  border-bottom: 1px solid var(--s-100);
  border-top: 1px solid var(--s-100);
  cursor: grab;
  display: flex;
  justify-content: space-between;
  margin: 0;
  padding: var(--space-small) var(--space-normal);
  user-select: none;
  width: 100%;

  h5 {
    font-size: var(--font-size-normal);
    margin-bottom: 0;
    padding: 0 var(--space-small) 0 0;
  }
}

.cw-accordion--title-wrap {
  display: flex;
  justify-content: space-between;
  margin-bottom: var(--space-micro);
}

.title-icon__wrap {
  display: flex;
  align-items: baseline;
}

.icon-or-emoji {
  display: inline-block;
  width: var(--space-two);
}

.button-icon--wrap {
  display: flex;
  flex-direction: row;
}

.chevron-icon__wrap {
  display: flex;
  justify-content: flex-end;
  width: var(--space-normal);
  color: var(--c-500);

  &.is-open {
    svg {
      transform: rotate(180deg);
    }
  }

  svg {
    transition: transform 0.3s ease;
  }
}

.cw-accordion--content-wrap{
  display: grid;
  grid-template-rows: 1fr;
}

.cw-accordion--content {
  min-height: 0;
  overflow: hidden;

  &.compact {
    padding: 0;
  }
}

.cw-accordion--internal-content {
  padding: var(--space-normal);
}

.slide-enter-active,
.slide-leave-active {
  transition: grid-template-rows 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.slide-enter,
.slide-leave-to {
  grid-template-rows: 0fr;
}

.slide-enter-to,
.slide-leave {
  grid-template-rows: 1fr;
}
</style>
